
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as jwt5B7IoSocg2eR5qcDyPvVIg8yTfulxnYOYyOl_c_45bru8Meta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/jwt.vue?macro=true";
import { default as riseidp9_JcJ_zC7zV7iJoOCq63fJhY2sokk3S_45YRLvPEJC0gMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund/riseid.vue?macro=true";
import { default as depositnVlaLHA4eRU1xut9Xpd_oan_wuLEMZVCLc8hAjQT9WgMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund/deposit.vue?macro=true";
import { default as deposit_45uskvarFNYCqXzcXfseNmKuOutbGkIWdEvukX5zj6yd0LQMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund/deposit-us.vue?macro=true";
import { default as _91accountId_93CldpT_45mpdGhMGRrcmMFl1Jk0fn9XvLRSLL_VD1K6vzMMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund/external-account/[accountId].vue?macro=true";
import { default as _91accountId_939Y4aePsVlyzUrd49VmN76sKqRLk0oE_45DnZUo9DuGak4Meta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund/dedicated-address/[accountId].vue?macro=true";
import { default as fund93QctzxQXOol7zBsKntJxxEJGNZhmlsspxd5eFGVeMUMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund.vue?macro=true";
import { default as indexa2A7kElXQ6NOnfQeA9g7ZQ4IiAKQzqIbSLB83sWHfaAMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/index.vue?macro=true";
import { default as riseid_45G79ivfhklXpry8ks8PuUhzBij4bObMdvnHlMoFJ_45S4Meta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/riseid.vue?macro=true";
import { default as accountjYqG4sV_dUmRw9w9IiCTyrtqnRQ47kqP1eT7W3ps4q0Meta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/account.vue?macro=true";
import { default as blockedvvM_Gna2lRiaukK47pGDuMI23rPEJwsmIaMDIUgvbrgMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/blocked.vue?macro=true";
import { default as referrald1DTbFZ7qEVCzwQe5vK3Vp9duWTPGkSjvTAINhmlVfwMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/referral.vue?macro=true";
import { default as securityRfEHseaZR7BKLivyw16UeX80Gp6QNlV1XOO0Y5u8q1MMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/security.vue?macro=true";
import { default as sign_45outHP7a4BcXfbKNe1dsmb8xkIlLUPAtfSlR7twVZeCovRwMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-out.vue?macro=true";
import { default as _91accountId_93_45M0_siB59mgLHvD07Vu58YtKKr7kcX4aIpbGY4YwtWMMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/withdraw/wire/[accountId].vue?macro=true";
import { default as _91accountId_938m6HDQ8re_45mvbQiUqjsFYXscpOVrQsUpwsHh_lvcspAMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/withdraw/blockchain/[accountId].vue?macro=true";
import { default as withdraw5Xuq3LgoP6S_45o_454zGKtYR1eMWI6eVsIU74xNPlLWnPsMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/withdraw.vue?macro=true";
import { default as dashboardwRw6BnE7aaaAm5IUJHJ8jMWY3xYQx7GdbYk668znfEAMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/dashboard.vue?macro=true";
import { default as developerER3_cwQZXiK5RacjO2n40p7RG3XdQV5dom1OqUfcdLEMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/developer.vue?macro=true";
import { default as loginPrHiSv88VyRes5XJ6CCquiOnXRzd8P7_45ML2YvlMdwWcMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/auth/login.vue?macro=true";
import { default as onboarding7McvfUc_qoWwp7YwADj_458tK_jJw9a4vqTDyDJ_oxBzMMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/onboarding.vue?macro=true";
import { default as playgroundH0DkrEjKehLHyDdR_45sobJrN81pG4xcErCu8Wr2KnqkMMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/playground.vue?macro=true";
import { default as _2faw_45vaGmPhscmuJXogFRIrHtdb7JD0tUftROdiNU0hjJoMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-in/2fa.vue?macro=true";
import { default as indexs0yVoNL6iq7hrOUDPssCjOHC4FnrL3dZRb5_01zr5HMMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/tasks/index.vue?macro=true";
import { default as codeNmILXA_AC4PkBIG37NSFsE7ioLkbyIkLgq2O9iEV2J4Meta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-in/code.vue?macro=true";
import { default as codeA7xexvW_LeavZzhaExYSlJ6wMwPIkAWwdMQrnMUT67UMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-up/code.vue?macro=true";
import { default as indexUiIupD6x9j8Hm6IDkNEXz7OkqjpGVSYhHeKVZneT834Meta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/index.vue?macro=true";
import { default as registerPSTrGed8FVW08yuXknA9uQIB7Htrr7wPJIH2ml56zrUMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/auth/register.vue?macro=true";
import { default as indexMduBEBzCk1r3XTKt5285BU7XTM4nvPnOovGMBkeoihkMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/clients/index.vue?macro=true";
import { default as _91code_93GKN9hJGjeY9DaTsTObhMFq_45EKj3JYCDk3uQ_45O5HwJV4Meta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/invite/[code].vue?macro=true";
import { default as indexfB4U3sudVZ8R1SYczTiYQAaVODG1ORgTWlwe6PG7X_45gMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/profile/index.vue?macro=true";
import { default as sign_45documentk1RnafqoLlg7sIozhsynTw4TvBJvZ4N6e55FeDTj2vsMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-document.vue?macro=true";
import { default as indexSOXruyLMDsw8_45uJZnsIUhwGv34Yq2o5UzM0QE4HBGPgMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-in/index.vue?macro=true";
import { default as index_45bw6Ik5AEa3T8Jlq2rhjM8h_45dYCXbaz0IHFtKBDbdCkMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-up/index.vue?macro=true";
import { default as importoFFP18pmqskUY4LEWhx6aG3juSnNm3Gntjx4fJLJSk0Meta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/import.vue?macro=true";
import { default as directv0hYYwF6g7sgBfaWZWXuBwqOhdKnDOWnuQrlz5yR_FYMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/direct.vue?macro=true";
import { default as sumsubTBYEhNfG_tGkKoG6hHLXxZ8xUkOnjyk4VPVq5sEBsW0Meta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/sumsub.vue?macro=true";
import { default as warmedFDeA8bM1u2aeNjINi8xbSM4MkWh4VUaHREKxadOoW6gMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/warmed.vue?macro=true";
import { default as batch_warmedPVvjgJrCXsgzJdrLttOZ0VwMZeILswtM4bZMGoM4DU8Meta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/batch_warmed.vue?macro=true";
import { default as warmed_lightcCyT1KamIX6PfU9cS27LTHn5CcsKdro_ynFkDqwhk9gMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/warmed_light.vue?macro=true";
import { default as batch_warmed_lightEkliAS3fbnYxrOzVy3AMNDR8Ni0OhN_YuIOEhYy_uZIMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/batch_warmed_light.vue?macro=true";
import { default as inviteASWW3jNd5eK360ddESdK5FK8Ygyeq4URoX4itbYTXwoMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite.vue?macro=true";
import { default as indexvo_45DWAK92TGhrWdr9kyFvBYYYefG6Qggr8juIlH6YfYMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/invoices/index.vue?macro=true";
import { default as indexY1VmIedboULkVzZMB2EYyBr7MV3sF8X23IVsmAq_45Z_0Meta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/index.vue?macro=true";
import { default as indexm8O5IPs8g5WlGIro2XhV5ZDdq1vBDlGgf93tObUfE9IMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/documents/index.vue?macro=true";
import { default as waiting6GuVdle4ZOJucRQjb_I64BGudkKWoD1AotxgpjfVXhIMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-up/waiting.vue?macro=true";
import { default as business_aXbvXngOUYQqn4oiUjOzPi5wpVWVW5xlGBrIwNhaMQMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/profile/business.vue?macro=true";
import { default as callbackkVv_45aFxKfPzOakrFeWR7urawEVqQjW41fpBC2gxvinkMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-in/callback.vue?macro=true";
import { default as _91id_93_2dSUNGICw_uQdmMKSrDQsVZM8SZg4kPp2wL4tDWhx0Meta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/invoices/add/[id].vue?macro=true";
import { default as once2FGRuczYerj23cX4nPpKXkpe2nX1SA4tkLjKb7iCqocMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/[userId]/once.vue?macro=true";
import { default as hourlyHEb7wWOwcT4gSwZKQnhivW3pbmd2vJnUgHO0UonbXFkMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/[userId]/hourly.vue?macro=true";
import { default as instantb4L6MXd7xKGBD6xCP2D7tHzql_45l1RsXJlvuVo48nLsYMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/[userId]/instant.vue?macro=true";
import { default as milestonebNhVuXpaiw_0JY_baXJ_wdCePiIb6PMkMuq_45803jr_8Meta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/[userId]/milestone.vue?macro=true";
import { default as recurringykJFpc5n0gGTr3uWPnjgC5OowxfI6hw_457Pw9X2gz25kMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/[userId]/recurring.vue?macro=true";
import { default as _91userId_93oLKjeL9gg1oZwvIXgoSmz6dsO6FIsN1_Zv96ZbcUFTgMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/[userId].vue?macro=true";
import { default as indexNRNx2DzJlaV0NCGYVDnhaWJqweziIPOFelNbuKRLqTIMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/[id]/index.vue?macro=true";
import { default as _91uuid_93tqIY_s63hhEsnN894sRZR0lX8YfLuClmxACUvFGoY9gMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/auth/invite/[uuid].vue?macro=true";
import { default as index5Ix9IXYEtlh9Ttt_45_DyAKASvh2HuEGNAelQaP2v_6CMMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/clients/[id]/index.vue?macro=true";
import { default as index5Wp97IWirvo8tmtosNrDGo0LtJBolh18Hvsjo_Ls9gEMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/invoices/add/index.vue?macro=true";
import { default as csvOU4uHj39swlVyle3VHNGDDigK9iFriimZBgdxUGAZB0Meta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/batch/csv.vue?macro=true";
import { default as indexMwZZIzQw2OO2_45Ii5ownqt7kg7ofPC5Jl5al7z9E3P4UMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/subscription/index.vue?macro=true";
import { default as managementFN7kDntTQV8FophLW7nmS99ew0jKXCDGiO2Kl7zZekYMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/management.vue?macro=true";
import { default as indexeS0KnEXKDeUXAJ13g3I5qf0G0s1fbA5rDXLn7Od7uYwMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/batch/index.vue?macro=true";
import { default as optionssvaFWmUSwtiCABdiJbOuZpLhyGw0GZN4sVrkjJcYbTsMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/subscription/options.vue?macro=true";
import { default as riseid_45erc20_45withdraw98Zrf2Ih_45kcbOhTcXt8tRuanj6clLfcjTNuW9totz_45gMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/riseid-erc20-withdraw.vue?macro=true";
import { default as _91token_93kzOSTxsaK8kiEKOsrlxEbyMCWsScrUl9PuoAIlEG4ugMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/auth/invite/b2b/[token].vue?macro=true";
import { default as index5v7wl_uui_LhcgEt7zZLeZHX5pVYWnU2ut4XUjHW9J8Meta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/management/company/index.vue?macro=true";
import { default as indexWD2a5MeZTsTpAhKBlRNCxhUPlOACYP8mPfRlAFp_45LSQMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/timesheets/index.vue?macro=true";
import { default as indexEs8qlwsGOL6BBqDhvG7WLX24jwc6d2_03OovKgkq9c4Meta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-funding/index.vue?macro=true";
import { default as _91psId_93lDUT7DToKCts5puaGvJoSQIaa3GdKc1y27eExefTTHEMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/timesheets/[psId].vue?macro=true";
import { default as index6_45BoJSpbwB2KWTE6j7q0qzO3OKHkU9AhkqYm4syzcT8Meta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/index.vue?macro=true";
import { default as ramps8B17LiXWjRPIGSQKdkHEfvnpLaPk_457d3ho_FZzzUw8kMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/ramps.vue?macro=true";
import { default as classification8sQYFroBu4rb5roQc3urJ7pcWs3ISU4yOG2rrqHqvmAMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/clients/[id]/classification.vue?macro=true";
import { default as _91id_93vczZQ7z4vNC36EcirYQa49Q5TFoBGlBSPmVFC9Ne_45roMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/receipts/fund/[id].vue?macro=true";
import { default as blockchain_45walletikgGexYB_lURsXPSlAilG_45zrBg58LNBH9E3ydMHSXmAMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-funding/options/blockchain-wallet.vue?macro=true";
import { default as dedicated_45addresse4_45guwCna9Qd3fC7mMMczz_waUtljNQGr4ge0Yc4XIMMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-funding/options/dedicated-address.vue?macro=true";
import { default as optionsuDF2OFqFXLpthPRTnmzynddcUUytuX8JnOpfODdon54Meta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-funding/options.vue?macro=true";
import { default as transaction_45historyz_D3OrjDrQ086hhG58XUfHgif_45vLGNNvOxK5A7x2v1YMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/transaction-history.vue?macro=true";
import { default as usj9eihufoBAXwmgmmd9wKnos2JK_45qAliFl5JigUelNCoMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/us.vue?macro=true";
import { default as eurvxBmpyeieFLWFA13wPd79GSO2XGpQzfA_45jZXiBqIOUsMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/eur.vue?macro=true";
import { default as gbp0mT2C6c9sg_45SWFWxa5qmoDLzRSa8t8BZwKodm5hObs0Meta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/gbp.vue?macro=true";
import { default as ngn20i0vjD36yru0h42shwQXvqqlD03wdju3NC2Ux8KS8MMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/ngn.vue?macro=true";
import { default as brlac5vSlCtDDade2n7l_tW0INfsFQZ_45NHyXs3OkEzWpDf8Meta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/brla.vue?macro=true";
import { default as forexKRtj0Ao0pDawQ5Np1dcIpFuCgtdFjsmMy6QO9dif91UMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/forex.vue?macro=true";
import { default as krakenRO2sGFe4yApw2AfrqDFt2FXenmCOsGJCDhA2G3XTt08Meta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/kraken.vue?macro=true";
import { default as binancelMpYb_45CQ5b6Vx3uZy8lB_4565MTT8vo7Cr3xHLUoAgQ6kMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/binance.vue?macro=true";
import { default as coinbaseDO5rmWQn1_45SPxHYXKg42m5_3VRN9wDnKUj_4Wb9k3xQMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/coinbase.vue?macro=true";
import { default as internationaltheUYupNPfi9svGZ4XWGmBB6RItSQp6pqiCd9fjfMgMMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/international.vue?macro=true";
import { default as coinbase_walletuihnsR_W1_45TmQbtvsIOtzlqVBEZdvvM_UbGPQmtJWswMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/coinbase_wallet.vue?macro=true";
import { default as international_bankNjDI_cHICxPkSCIgkDVKTerLGF8Ukp1EmOzKcy6P1U0Meta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/international_bank.vue?macro=true";
import { default as indexoNxNg_wM1CxvxgTpr_45TB1fK_tTa8dmJLkKsIlSiiTGQMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/blockchain-wallet/index.vue?macro=true";
import { default as _91network_9345R3_2ElpPgOf7gO6vD4mowj7_45LmWFdu5lbmYLbqBkAMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/blockchain-wallet/[network].vue?macro=true";
import { default as optionsYSBhPTqqV5STT54s_45dULIbJyKSisPLIEWBC8RuUSpBwMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options.vue?macro=true";
import { default as coinbaselCtkVJHI2R_459aiuYnW7pibKBS1jGU_456IoQ_45sxR_45OjVQMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add/callback/coinbase.vue?macro=true";
import { default as teamtbUA_45wL6eoLKdIqUSLeVNSq5dkTN7L78mjQfwJUzFxoMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/management/company/create/team.vue?macro=true";
import { default as _91id_93Fyq35o8EErHkk4zmLnl_caaDxvXpVDqfyewhzRSAebYMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/receipts/payment/[id].vue?macro=true";
import { default as indexSqb1BLlnuM0HtWKOAMb3UUh6qOISEpLXh4O463MW_45ToMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/management/company/create/index.vue?macro=true";
import { default as verify_45walletbl9xGRPAG20lhLRYt5JSs4PQoJt1MbsykGtRvDGYBpYMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add/callback/verify-wallet.vue?macro=true";
import { default as pay_scheduleSFQKBiuA_45MDKqEcbU8OiDQTAIZWcOiSOJjoval5LaE0Meta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/documents/[payschedule]/pay_schedule.vue?macro=true";
export default [
  {
    name: "jwt",
    path: "/jwt",
    meta: jwt5B7IoSocg2eR5qcDyPvVIg8yTfulxnYOYyOl_c_45bru8Meta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/jwt.vue")
  },
  {
    name: "fund",
    path: "/fund",
    meta: fund93QctzxQXOol7zBsKntJxxEJGNZhmlsspxd5eFGVeMUMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund.vue"),
    children: [
  {
    name: "fund-riseid",
    path: "riseid",
    meta: riseidp9_JcJ_zC7zV7iJoOCq63fJhY2sokk3S_45YRLvPEJC0gMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund/riseid.vue")
  },
  {
    name: "fund-deposit",
    path: "deposit",
    meta: depositnVlaLHA4eRU1xut9Xpd_oan_wuLEMZVCLc8hAjQT9WgMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund/deposit.vue")
  },
  {
    name: "fund-deposit-us",
    path: "deposit-us",
    meta: deposit_45uskvarFNYCqXzcXfseNmKuOutbGkIWdEvukX5zj6yd0LQMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund/deposit-us.vue")
  },
  {
    name: "fund-external-account-accountId",
    path: "external-account/:accountId()",
    meta: _91accountId_93CldpT_45mpdGhMGRrcmMFl1Jk0fn9XvLRSLL_VD1K6vzMMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund/external-account/[accountId].vue")
  },
  {
    name: "fund-dedicated-address-accountId",
    path: "dedicated-address/:accountId()",
    meta: _91accountId_939Y4aePsVlyzUrd49VmN76sKqRLk0oE_45DnZUo9DuGak4Meta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund/dedicated-address/[accountId].vue")
  }
]
  },
  {
    name: "index",
    path: "/",
    meta: indexa2A7kElXQ6NOnfQeA9g7ZQ4IiAKQzqIbSLB83sWHfaAMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/index.vue")
  },
  {
    name: "riseid",
    path: "/riseid",
    meta: riseid_45G79ivfhklXpry8ks8PuUhzBij4bObMdvnHlMoFJ_45S4Meta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/riseid.vue")
  },
  {
    name: "account",
    path: "/account",
    meta: accountjYqG4sV_dUmRw9w9IiCTyrtqnRQ47kqP1eT7W3ps4q0Meta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/account.vue")
  },
  {
    name: "blocked",
    path: "/blocked",
    meta: blockedvvM_Gna2lRiaukK47pGDuMI23rPEJwsmIaMDIUgvbrgMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/blocked.vue")
  },
  {
    name: "referral",
    path: "/referral",
    meta: referrald1DTbFZ7qEVCzwQe5vK3Vp9duWTPGkSjvTAINhmlVfwMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/referral.vue")
  },
  {
    name: "security",
    path: "/security",
    meta: securityRfEHseaZR7BKLivyw16UeX80Gp6QNlV1XOO0Y5u8q1MMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/security.vue")
  },
  {
    name: "sign-out",
    path: "/sign-out",
    meta: sign_45outHP7a4BcXfbKNe1dsmb8xkIlLUPAtfSlR7twVZeCovRwMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-out.vue")
  },
  {
    name: "withdraw",
    path: "/withdraw",
    meta: withdraw5Xuq3LgoP6S_45o_454zGKtYR1eMWI6eVsIU74xNPlLWnPsMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/withdraw.vue"),
    children: [
  {
    name: "withdraw-wire-accountId",
    path: "wire/:accountId()",
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/withdraw/wire/[accountId].vue")
  },
  {
    name: "withdraw-blockchain-accountId",
    path: "blockchain/:accountId()",
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/withdraw/blockchain/[accountId].vue")
  }
]
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: dashboardwRw6BnE7aaaAm5IUJHJ8jMWY3xYQx7GdbYk668znfEAMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/dashboard.vue")
  },
  {
    name: "developer",
    path: "/developer",
    meta: developerER3_cwQZXiK5RacjO2n40p7RG3XdQV5dom1OqUfcdLEMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/developer.vue")
  },
  {
    name: "auth-login",
    path: "/auth/login",
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/auth/login.vue")
  },
  {
    name: "onboarding",
    path: "/onboarding",
    meta: onboarding7McvfUc_qoWwp7YwADj_458tK_jJw9a4vqTDyDJ_oxBzMMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/onboarding.vue")
  },
  {
    name: "playground",
    path: "/playground",
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/playground.vue")
  },
  {
    name: "sign-in-2fa",
    path: "/sign-in/2fa",
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-in/2fa.vue")
  },
  {
    name: "tasks",
    path: "/tasks",
    meta: indexs0yVoNL6iq7hrOUDPssCjOHC4FnrL3dZRb5_01zr5HMMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/tasks/index.vue")
  },
  {
    name: "sign-in-code",
    path: "/sign-in/code",
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-in/code.vue")
  },
  {
    name: "sign-up-code",
    path: "/sign-up/code",
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-up/code.vue")
  },
  {
    name: "talent",
    path: "/talent",
    meta: indexUiIupD6x9j8Hm6IDkNEXz7OkqjpGVSYhHeKVZneT834Meta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/index.vue")
  },
  {
    name: "auth-register",
    path: "/auth/register",
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/auth/register.vue")
  },
  {
    name: "clients",
    path: "/clients",
    meta: indexMduBEBzCk1r3XTKt5285BU7XTM4nvPnOovGMBkeoihkMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/clients/index.vue")
  },
  {
    name: "invite-code",
    path: "/invite/:code()",
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/invite/[code].vue")
  },
  {
    name: "profile",
    path: "/profile",
    meta: indexfB4U3sudVZ8R1SYczTiYQAaVODG1ORgTWlwe6PG7X_45gMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/profile/index.vue")
  },
  {
    name: "sign-document",
    path: "/sign-document",
    meta: sign_45documentk1RnafqoLlg7sIozhsynTw4TvBJvZ4N6e55FeDTj2vsMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-document.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-up/index.vue")
  },
  {
    name: "talent-import",
    path: "/talent/import",
    meta: importoFFP18pmqskUY4LEWhx6aG3juSnNm3Gntjx4fJLJSk0Meta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/import.vue")
  },
  {
    name: "talent-invite",
    path: "/talent/invite",
    meta: inviteASWW3jNd5eK360ddESdK5FK8Ygyeq4URoX4itbYTXwoMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite.vue"),
    children: [
  {
    name: "talent-invite-direct",
    path: "direct",
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/direct.vue")
  },
  {
    name: "talent-invite-sumsub",
    path: "sumsub",
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/sumsub.vue")
  },
  {
    name: "talent-invite-warmed",
    path: "warmed",
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/warmed.vue")
  },
  {
    name: "talent-invite-batch_warmed",
    path: "batch_warmed",
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/batch_warmed.vue")
  },
  {
    name: "talent-invite-warmed_light",
    path: "warmed_light",
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/warmed_light.vue")
  },
  {
    name: "talent-invite-batch_warmed_light",
    path: "batch_warmed_light",
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/batch_warmed_light.vue")
  }
]
  },
  {
    name: "invoices",
    path: "/invoices",
    meta: indexvo_45DWAK92TGhrWdr9kyFvBYYYefG6Qggr8juIlH6YfYMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/invoices/index.vue")
  },
  {
    name: "payments",
    path: "/payments",
    meta: indexY1VmIedboULkVzZMB2EYyBr7MV3sF8X23IVsmAq_45Z_0Meta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/index.vue")
  },
  {
    name: "documents",
    path: "/documents",
    meta: indexm8O5IPs8g5WlGIro2XhV5ZDdq1vBDlGgf93tObUfE9IMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/documents/index.vue")
  },
  {
    name: "sign-up-waiting",
    path: "/sign-up/waiting",
    meta: waiting6GuVdle4ZOJucRQjb_I64BGudkKWoD1AotxgpjfVXhIMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-up/waiting.vue")
  },
  {
    name: "profile-business",
    path: "/profile/business",
    meta: business_aXbvXngOUYQqn4oiUjOzPi5wpVWVW5xlGBrIwNhaMQMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/profile/business.vue")
  },
  {
    name: "sign-in-callback",
    path: "/sign-in/callback",
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-in/callback.vue")
  },
  {
    name: "invoices-add-id",
    path: "/invoices/add/:id()",
    meta: _91id_93_2dSUNGICw_uQdmMKSrDQsVZM8SZg4kPp2wL4tDWhx0Meta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/invoices/add/[id].vue")
  },
  {
    name: "payments-userId",
    path: "/payments/:userId()",
    meta: _91userId_93oLKjeL9gg1oZwvIXgoSmz6dsO6FIsN1_Zv96ZbcUFTgMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/[userId].vue"),
    children: [
  {
    name: "payments-userId-once",
    path: "once",
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/[userId]/once.vue")
  },
  {
    name: "payments-userId-hourly",
    path: "hourly",
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/[userId]/hourly.vue")
  },
  {
    name: "payments-userId-instant",
    path: "instant",
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/[userId]/instant.vue")
  },
  {
    name: "payments-userId-milestone",
    path: "milestone",
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/[userId]/milestone.vue")
  },
  {
    name: "payments-userId-recurring",
    path: "recurring",
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/[userId]/recurring.vue")
  }
]
  },
  {
    name: "talent-id",
    path: "/talent/:id()",
    meta: indexNRNx2DzJlaV0NCGYVDnhaWJqweziIPOFelNbuKRLqTIMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/[id]/index.vue")
  },
  {
    name: "auth-invite-uuid",
    path: "/auth/invite/:uuid()",
    meta: _91uuid_93tqIY_s63hhEsnN894sRZR0lX8YfLuClmxACUvFGoY9gMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/auth/invite/[uuid].vue")
  },
  {
    name: "clients-id",
    path: "/clients/:id()",
    meta: index5Ix9IXYEtlh9Ttt_45_DyAKASvh2HuEGNAelQaP2v_6CMMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/clients/[id]/index.vue")
  },
  {
    name: "invoices-add",
    path: "/invoices/add",
    meta: index5Wp97IWirvo8tmtosNrDGo0LtJBolh18Hvsjo_Ls9gEMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/invoices/add/index.vue")
  },
  {
    name: "payments-batch-csv",
    path: "/payments/batch/csv",
    meta: csvOU4uHj39swlVyle3VHNGDDigK9iFriimZBgdxUGAZB0Meta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/batch/csv.vue")
  },
  {
    name: "subscription",
    path: "/subscription",
    meta: indexMwZZIzQw2OO2_45Ii5ownqt7kg7ofPC5Jl5al7z9E3P4UMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/subscription/index.vue")
  },
  {
    name: "payments-management",
    path: "/payments/management",
    meta: managementFN7kDntTQV8FophLW7nmS99ew0jKXCDGiO2Kl7zZekYMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/management.vue")
  },
  {
    name: "payments-batch",
    path: "/payments/batch",
    meta: indexeS0KnEXKDeUXAJ13g3I5qf0G0s1fbA5rDXLn7Od7uYwMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/batch/index.vue")
  },
  {
    name: "subscription-options",
    path: "/subscription/options",
    meta: optionssvaFWmUSwtiCABdiJbOuZpLhyGw0GZN4sVrkjJcYbTsMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/subscription/options.vue")
  },
  {
    name: "riseid-erc20-withdraw",
    path: "/riseid-erc20-withdraw",
    meta: riseid_45erc20_45withdraw98Zrf2Ih_45kcbOhTcXt8tRuanj6clLfcjTNuW9totz_45gMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/riseid-erc20-withdraw.vue")
  },
  {
    name: "auth-invite-b2b-token",
    path: "/auth/invite/b2b/:token()",
    meta: _91token_93kzOSTxsaK8kiEKOsrlxEbyMCWsScrUl9PuoAIlEG4ugMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/auth/invite/b2b/[token].vue")
  },
  {
    name: "management-company",
    path: "/management/company",
    meta: index5v7wl_uui_LhcgEt7zZLeZHX5pVYWnU2ut4XUjHW9J8Meta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/management/company/index.vue")
  },
  {
    name: "payments-timesheets",
    path: "/payments/timesheets",
    meta: indexWD2a5MeZTsTpAhKBlRNCxhUPlOACYP8mPfRlAFp_45LSQMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/timesheets/index.vue")
  },
  {
    name: "accounts-add-funding",
    path: "/accounts/add-funding",
    meta: indexEs8qlwsGOL6BBqDhvG7WLX24jwc6d2_03OovKgkq9c4Meta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-funding/index.vue")
  },
  {
    name: "payments-timesheets-psId",
    path: "/payments/timesheets/:psId()",
    meta: _91psId_93lDUT7DToKCts5puaGvJoSQIaa3GdKc1y27eExefTTHEMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/timesheets/[psId].vue")
  },
  {
    name: "accounts-add-withdraw",
    path: "/accounts/add-withdraw",
    meta: index6_45BoJSpbwB2KWTE6j7q0qzO3OKHkU9AhkqYm4syzcT8Meta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/index.vue")
  },
  {
    name: "accounts-add-withdraw-ramps",
    path: "/accounts/add-withdraw/ramps",
    meta: ramps8B17LiXWjRPIGSQKdkHEfvnpLaPk_457d3ho_FZzzUw8kMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/ramps.vue")
  },
  {
    name: "clients-id-classification",
    path: "/clients/:id()/classification",
    meta: classification8sQYFroBu4rb5roQc3urJ7pcWs3ISU4yOG2rrqHqvmAMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/clients/[id]/classification.vue")
  },
  {
    name: "payments-receipts-fund-id",
    path: "/payments/receipts/fund/:id()",
    meta: _91id_93vczZQ7z4vNC36EcirYQa49Q5TFoBGlBSPmVFC9Ne_45roMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/receipts/fund/[id].vue")
  },
  {
    name: "accounts-add-funding-options",
    path: "/accounts/add-funding/options",
    meta: optionsuDF2OFqFXLpthPRTnmzynddcUUytuX8JnOpfODdon54Meta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-funding/options.vue"),
    children: [
  {
    name: "accounts-add-funding-options-blockchain-wallet",
    path: "blockchain-wallet",
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-funding/options/blockchain-wallet.vue")
  },
  {
    name: "accounts-add-funding-options-dedicated-address",
    path: "dedicated-address",
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-funding/options/dedicated-address.vue")
  }
]
  },
  {
    name: "payments-transaction-history",
    path: "/payments/transaction-history",
    meta: transaction_45historyz_D3OrjDrQ086hhG58XUfHgif_45vLGNNvOxK5A7x2v1YMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/transaction-history.vue")
  },
  {
    name: "accounts-add-withdraw-options",
    path: "/accounts/add-withdraw/options",
    meta: optionsYSBhPTqqV5STT54s_45dULIbJyKSisPLIEWBC8RuUSpBwMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options.vue"),
    children: [
  {
    name: "accounts-add-withdraw-options-us",
    path: "us",
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/us.vue")
  },
  {
    name: "accounts-add-withdraw-options-eur",
    path: "eur",
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/eur.vue")
  },
  {
    name: "accounts-add-withdraw-options-gbp",
    path: "gbp",
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/gbp.vue")
  },
  {
    name: "accounts-add-withdraw-options-ngn",
    path: "ngn",
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/ngn.vue")
  },
  {
    name: "accounts-add-withdraw-options-brla",
    path: "brla",
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/brla.vue")
  },
  {
    name: "accounts-add-withdraw-options-forex",
    path: "forex",
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/forex.vue")
  },
  {
    name: "accounts-add-withdraw-options-kraken",
    path: "kraken",
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/kraken.vue")
  },
  {
    name: "accounts-add-withdraw-options-binance",
    path: "binance",
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/binance.vue")
  },
  {
    name: "accounts-add-withdraw-options-coinbase",
    path: "coinbase",
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/coinbase.vue")
  },
  {
    name: "accounts-add-withdraw-options-international",
    path: "international",
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/international.vue")
  },
  {
    name: "accounts-add-withdraw-options-coinbase_wallet",
    path: "coinbase_wallet",
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/coinbase_wallet.vue")
  },
  {
    name: "accounts-add-withdraw-options-international_bank",
    path: "international_bank",
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/international_bank.vue")
  },
  {
    name: "accounts-add-withdraw-options-blockchain-wallet",
    path: "blockchain-wallet",
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/blockchain-wallet/index.vue")
  },
  {
    name: "accounts-add-withdraw-options-blockchain-wallet-network",
    path: "blockchain-wallet/:network()",
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/blockchain-wallet/[network].vue")
  }
]
  },
  {
    name: "accounts-add-callback-coinbase",
    path: "/accounts/add/callback/coinbase",
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add/callback/coinbase.vue")
  },
  {
    name: "management-company-create-team",
    path: "/management/company/create/team",
    meta: teamtbUA_45wL6eoLKdIqUSLeVNSq5dkTN7L78mjQfwJUzFxoMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/management/company/create/team.vue")
  },
  {
    name: "payments-receipts-payment-id",
    path: "/payments/receipts/payment/:id()",
    meta: _91id_93Fyq35o8EErHkk4zmLnl_caaDxvXpVDqfyewhzRSAebYMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/receipts/payment/[id].vue")
  },
  {
    name: "management-company-create",
    path: "/management/company/create",
    meta: indexSqb1BLlnuM0HtWKOAMb3UUh6qOISEpLXh4O463MW_45ToMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/management/company/create/index.vue")
  },
  {
    name: "accounts-add-callback-verify-wallet",
    path: "/accounts/add/callback/verify-wallet",
    meta: verify_45walletbl9xGRPAG20lhLRYt5JSs4PQoJt1MbsykGtRvDGYBpYMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add/callback/verify-wallet.vue")
  },
  {
    name: "documents-payschedule-pay_schedule",
    path: "/documents/:payschedule()/pay_schedule",
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/documents/[payschedule]/pay_schedule.vue")
  }
]